export default { sha: '50a31a35d23c5677e91253dd09a4510b7fa974ed', buildNumber: 'undefined' }
